import {Component, Input, Output, EventEmitter} from '@angular/core';
import {ClaimDto} from "../../../../auto-generated-server-dtos/adjuster/claim/claim-dto";
import {SubmitClaimService} from "../../../../claim/services/submit-claim.service";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {UpdateModalComponent} from "../update-modal/update-modal.component";
import {GetClaimService} from "../services/get-claim.service";

@Component({
  selector: 'app-update-button',
  templateUrl: './update-button.component.html',
  styleUrl: './update-button.component.scss'
})
export class UpdateButtonComponent {
  @Input() busySubmitting = false;
  @Input() repairTotal = 0;
  @Input() isLocked = false;
  @Output() updateButtonClicked = new EventEmitter<string>();
    
  constructor() {}

  updateClaim() {
    this.updateButtonClicked.emit();
  }
}
